import React from 'react'
import { useHistory } from 'react-router-dom'
import { Layout } from '../../components/Layout'
import { ScheduleVisualCalendar } from '../../components/ScheduleVisualCalendar'
import { GLOBALS } from '../../utils/Globals'
import './styles.scss'

export const ScheduleVisual = () => {
  const history = useHistory()
  const config = {
    title: 'Visualización de Horarios',
    icon: GLOBALS.menu.scheduler.icon,
  }

  const handleTimeSlotSelect = (timeSlot) => {
    if (timeSlot && !timeSlot.isOccupied) {
      // Redirigir a crear reserva con los parámetros del horario seleccionado
      const params = new URLSearchParams({
        laboratory_id: timeSlot.laboratoryId || '',
        pod_id: timeSlot.podId || '',
        startDate: timeSlot.date || '',
      })
      history.push(`${GLOBALS.menu.scheduler.link}/create?${params.toString()}`)
    }
  }

  return (
    <Layout>
      <div className="schedule-visual-page">
        <div className="page-header">
          <h1>
            {config.icon && <i className={config.icon}></i>}
            {config.title}
          </h1>
        </div>

        <ScheduleVisualCalendar onTimeSlotSelect={handleTimeSlotSelect} allowSelection={true} />
      </div>
    </Layout>
  )
}
